import {
    DotsHorizontalIcon,
    Pencil1Icon,
} from '@radix-ui/react-icons';
import '../App.css';

import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { LittersDatatable } from '../components/datatables/littersDatatable';
import ChangeFarmBreederDialog from '../components/dialogs/changeFarmBreederDialog';
import CreateNewLitterDialog from '../components/dialogs/createNewLitterDialog';
import ExternalLinkWrapper from '../components/externalLinkWrapper';
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../components/ui/accordion";
import { Button } from '../components/ui/button';
import {
    Dialog,
} from "../components/ui/dialog";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";
import { Skeleton } from '../components/ui/skeleton';
import { toast } from '../components/ui/use-toast';
import { AuthContext } from '../context/AuthContext';
import api from '../lib/api';

function FarmSingle() {
    const navigate = useNavigate();

    const { farmId } = useParams();
    const { auth } = useContext(AuthContext);

    const [farm, setFarm] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchFarmInformation = useCallback(async () => {
        try {
            const response = await api.get(`https://skhrf-api.cmdigital.se/v1/farms/information?farmId=${farmId}`)
            setFarm(response.data);

        } catch (error) {
            if (error.response?.status === 404) {
                toast({
                    variant: 'destructive',
                    title: 'Något gick fel.',
                    description: 'Gården du efterfrågade finns inte.',
                });
                navigate(`/farms`);
            }
            console.error('Error fetching farm:', error);
        } finally {
            setIsLoading(false);
        }
    }, [farmId, navigate]);

    const fetchLitters = async () => {
        setIsLoading(true);
        try {
            const response = await api.get(`https://skhrf-api.cmdigital.se/v1/farms/litters?farmId=${farmId}`)

        } catch (error) {
            console.error('Error fetching litters:', error)
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchFarmInformation();
    }, [fetchFarmInformation]);

    return (
        <div className='flex w-full items-center justify-center'>
            <div className='flex w-5/6 sm:w-3/4 flex-col py-6 gap-3'>
                <div className='grid grid-cols-1 xl:grid-cols-2 items-center'>
                    <h1 className='font-medium text-2xl'>
                        {isLoading ? (<Skeleton className='h-10 w-52' />) : (
                            farm.name
                        )}
                    </h1>
                    <div className='grid grid-cols-1 sm:grid-cols-2 gap-3 pt-3'>
                        {(auth?.user?.superadmin || auth?.user?.bunnyadmin || (auth?.user?.id === farm.breeder_id)) && (
                            <>
                                <CreateNewLitterDialog farm={farm} fetchLitters={fetchLitters} />
                                <Dialog modal={true}>
                                    <DropdownMenu>
                                        <DropdownMenuTrigger asChild>
                                            <Button variant='secondary'><DotsHorizontalIcon className='mr-3' /> Verktyg</Button>
                                        </DropdownMenuTrigger>
                                        <DropdownMenuContent className='dropdown-content-width-full'>
                                            <DropdownMenuLabel>Verktyg</DropdownMenuLabel>
                                            <DropdownMenuSeparator />
                                            <DropdownMenuItem className='cursor-pointer' onClick={() => navigate(`/farms/${farm.id}/edit`)}>
                                                <Pencil1Icon className='mr-3' />
                                                Ändra gårdsinformation
                                            </DropdownMenuItem>
                                            {(auth?.user?.superadmin || auth?.user?.bunnyadmin) && (
                                                <ChangeFarmBreederDialog farm={farm} fetchFarmInformation={fetchFarmInformation} />
                                            )}
                                        </DropdownMenuContent>
                                    </DropdownMenu>
                                </Dialog>
                            </>
                        )}
                    </div>
                </div>
                <Accordion type="single" collapsible defaultValue='item-1'>
                    <AccordionItem value="item-1">
                        <AccordionTrigger>Allmän information</AccordionTrigger>
                        <AccordionContent className='flex flex-col gap-3'>
                            <div className='rounded-md bg-gray-100 p-3'>
                                <h2 className='font-medium text-md'>Gårdsinformation</h2>
                                {isLoading ? (<Skeleton className='w-64 h-4' />) : (
                                    <ExternalLinkWrapper>
                                        <div dangerouslySetInnerHTML={{ __html: farm.description }} />
                                    </ExternalLinkWrapper>
                                )}
                            </div>
                            <div className='rounded-md bg-gray-100 p-3'>
                                <h2 className='font-medium text-md'>Uppfödare</h2>
                                {isLoading ? (<Skeleton className='w-64 h-4' />) : (
                                    <div dangerouslySetInnerHTML={{ __html: farm.breeder_name }} />
                                )}
                            </div>
                        </AccordionContent>
                    </AccordionItem>
                    <AccordionItem value='item-2'>
                        <AccordionTrigger>Kullar</AccordionTrigger>
                        <AccordionContent>
                            <div className='rounded-md bg-gray-100 p-3'>
                                <LittersDatatable farmId={farmId} />
                            </div>
                        </AccordionContent>
                    </AccordionItem>
                </Accordion>
            </div>
        </div>
    );
}

export default FarmSingle;